import { Component, Input, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Constants } from 'src/app/shared/model/Constants';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'iban-input-ctrl',
  templateUrl: './iban-input.component.html',
  styleUrls: ['./iban-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: IbanInputComponent,
    multi: true
  }]
})
export class IbanInputComponent implements ControlValueAccessor  {

  constructor(protected controlContainer: ControlContainer) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {uppercase:false, fxFill:false,format: Constants.IbanFormatPL};

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
  }

  onChange(value: string) {
    if (this.settings.uppercase) {
      value = value.toUpperCase();
    }

    this.control.setValue(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
